import './index.css';

const DashboardHeader = ({ children }) => {
    return (
        <div className="dashboard-header">
            {children}
        </div>
    )
}

export default DashboardHeader;